export default {
    getHeaderFields: state => state.getHeaderFields,
    getPatientRowActions: state => state.patientRowActions,
    getPatientActions: state => state.patientActions,
    getAdditionalTableOptions: state => state.additionalTableOptions,
    getEmployeesFormActions: state => state.employeesFormActions,
}